import React from "react";

import styles from "./PaigeReview.module.scss";
import { isApproximatelyLocated } from "../../../../pdf/reviewRegions";

var FindingCard = function (props) {
  var finding = props.finding;
  var analysisType = props.analysisType;
  var onFindingClick = props.onFindingClick;

  var getSeverityClass = function () {
    switch (finding.severity) {
      case "critical":
        return styles.severityCritical;
      case "warning":
        return styles.severityWarning;
      case "info":
        return styles.severityInfo;
      default:
        return "";
    }
  };

  var handleClick = function () {
    if (onFindingClick && finding.page_number != null) {
      onFindingClick(finding);
    }
  };

  var renderCodeSection = function () {
    if (!finding.code_section) return null;

    // For PAAB, prefix with "PAAB Code"
    // For FDA, the code_section already contains the CFR citation (e.g., "21 CFR 202.1(e)(6)(i)")
    var label =
      analysisType === "fda"
        ? finding.code_section
        : "PAAB Code " + finding.code_section;

    return <span className={styles.codeSection}>{label}</span>;
  };

  return (
    <div className={styles.findingCard} onClick={handleClick}>
      <div className={styles.findingHeader}>
        <span className={styles.severityBadge + " " + getSeverityClass()}>
          {finding.severity}
        </span>
        <span className={styles.findingCategory}>{finding.category}</span>
        {renderCodeSection()}
      </div>

      <div className={styles.findingDescription}>{finding.description}</div>

      {finding.extracted_text && (
        <div className={styles.extractedText}>
          <span className={styles.quoteIcon}>"</span>
          {finding.extracted_text}
          <span className={styles.quoteIcon}>"</span>
        </div>
      )}

      {isApproximatelyLocated(finding) && (
        <div className={styles.approximateNote}>
          ≈ Approximate area on the page, estimated by Paige
        </div>
      )}

      {finding.recommendation && (
        <div className={styles.recommendation}>
          <div className={styles.recommendationLabel}>Recommendation</div>
          <div className={styles.recommendationText}>
            {finding.recommendation}
          </div>
        </div>
      )}

      {finding.page_number != null && (
        <div className={styles.findingFooter}>
          <span className={styles.pageNote}>Page {finding.page_number}</span>
        </div>
      )}
    </div>
  );
};

export default FindingCard;
